/**
 * Created by lu on 2018/4/8.
 */
var nb = require('../../../nb');
module.exports = nb.define({
    parent: require('../../../Model'),
    mapping: {
        content: require('./Content')
    },
    method: {
        init: function () {
            var self = this;
            this.set('header',{
                style:''
            });
            nb.model.onChange(nb.opts.clientReady, function () {
                var $document = $(document);
                $document.scroll(function () {
                    var scrollTop = $document.scrollTop(); //scrollTop() 方法返回或设置匹配元素的滚动条的垂直位置。
                    var style = '';
                    if (scrollTop > 20) {
                        style = 'default'
                    }
                    self.set('header', {
                        'style': style
                    });
                });
            }, this);
        },
        _checkCompleteInfo:function () {
            return false;
        },
        _isPageLogin:function () {
            return false;
        },
        _isOnlyWater:function () {
            return true;
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/page/index/model/Model.js
// module id = 516
// module chunks = 6